"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var bind_1 = require("../../bind");
var graphql_tag_1 = require("graphql-tag");
var react_apollo_1 = require("react-apollo");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var rql_1 = require("../../schemas/rql");
var form_group_1 = require("@reverbdotcom/commons/dist/components/form_group");
var form_group_with_input_1 = require("@reverbdotcom/commons/dist/components/form_group_with_input");
var form_group_with_radio_1 = require("@reverbdotcom/commons/dist/components/form_group_with_radio");
var star_rating_selector_1 = require("@reverbdotcom/commons/dist/components/star_rating_selector");
var parse_graphql_errors_1 = require("@reverbdotcom/commons/dist/parse_graphql_errors");
var url_helpers_1 = require("../shared/url_helpers");
var to_boolean_1 = require("../../reverb-js-common/to_boolean");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var html_translation_1 = require("@reverbdotcom/commons/dist/html_translation");
var updateFeedbackGQL = graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  mutation UpdateFeedback($input: Input_core_apimessages_UpdateFeedbackRequest) {\n    updateFeedbackRequest(input: $input) {\n      feedback {\n        rating\n        shippingSatisfactory {\n          value\n        }\n        conditionSatisfactory {\n          value\n        }\n        message\n      }\n    }\n  }\n"], ["\n  mutation UpdateFeedback($input: Input_core_apimessages_UpdateFeedbackRequest) {\n    updateFeedbackRequest(input: $input) {\n      feedback {\n        rating\n        shippingSatisfactory {\n          value\n        }\n        conditionSatisfactory {\n          value\n        }\n        message\n      }\n    }\n  }\n"])));
var updateFeedbackMutation = react_apollo_1.graphql(updateFeedbackGQL, {
    name: 'updateFeedbackMutation',
});
var FeedbackForm = /** @class */ (function (_super) {
    tslib_1.__extends(FeedbackForm, _super);
    function FeedbackForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            message: '',
            rating: null,
            shippingSatisfactory: null,
            conditionSatisfactory: null,
            submitDisabled: false,
        };
        return _this;
    }
    Object.defineProperty(FeedbackForm.prototype, "isLp", {
        get: function () {
            return this.props.channel === rql_1.core_apimessages_Channel.LP;
        },
        enumerable: true,
        configurable: true
    });
    FeedbackForm.prototype.showStructuredFeedback = function () {
        return this.isLp && this.props.isBuyer;
    };
    FeedbackForm.prototype.shippingSatisfactoryValue = function () {
        if (this.state.shippingSatisfactory === null) {
            return null;
        }
        return {
            value: this.state.shippingSatisfactory,
        };
    };
    FeedbackForm.prototype.conditionSatisfactoryValue = function () {
        if (this.state.conditionSatisfactory === null) {
            return null;
        }
        return {
            value: this.state.conditionSatisfactory,
        };
    };
    FeedbackForm.prototype.createFeedback = function () {
        this.setState({ submitDisabled: true });
        return this.props.updateFeedbackMutation({
            variables: {
                input: {
                    orderUuid: this.props.orderUuid,
                    rating: this.state.rating,
                    message: this.state.message,
                    shippingSatisfactory: this.shippingSatisfactoryValue(),
                    conditionSatisfactory: this.conditionSatisfactoryValue(),
                },
            },
        }).then(this.onSuccess, this.onError);
    };
    FeedbackForm.prototype.onSuccess = function () {
        this.props.onSuccess();
    };
    FeedbackForm.prototype.onError = function (errorResponse) {
        this.setState({ submitDisabled: false });
        this.props.onError(parse_graphql_errors_1.parseGraphqlErrors(errorResponse));
    };
    FeedbackForm.prototype.onValueChange = function (obj) {
        this.setState(obj);
    };
    FeedbackForm.prototype.starRatingSelected = function (starsSelected) {
        this.setState({ rating: starsSelected });
    };
    FeedbackForm.prototype.updateShipping = function (obj) {
        this.setState({ shippingSatisfactory: to_boolean_1.default(obj.shippingSatisfactory) });
    };
    FeedbackForm.prototype.updateCondition = function (obj) {
        this.setState({ conditionSatisfactory: to_boolean_1.default(obj.conditionSatisfactory) });
    };
    FeedbackForm.prototype.formValid = function () {
        if (this.state.rating === null) {
            return false;
        }
        if (this.showStructuredFeedback() &&
            (this.state.shippingSatisfactory === null || this.state.conditionSatisfactory === null)) {
            return false;
        }
        return true;
    };
    FeedbackForm.prototype.showStartAConversation = function () {
        return this.state.rating && this.state.rating > 0 && this.state.rating < 4;
    };
    FeedbackForm.prototype.buyerSuggestion = function () {
        var msgUrl = url_helpers_1.default.purchasePath({
            orderId: this.props.legacyOrderId,
        });
        var refundUrl = url_helpers_1.default.purchasePath({
            orderId: this.props.legacyOrderId,
            actions_expanded: true,
        });
        return (React.createElement("div", null,
            React.createElement(sanitized_render_1.default, { html: html_translation_1.translateElement('b', 'discovery.feedbackForm.problemsWithYourOrder') }),
            React.createElement("br", null),
            React.createElement(sanitized_render_1.default, { html: I18n.t('discovery.feedbackForm.buyerSuggestion', {
                    msgLinkOpen: "<a href=\"" + msgUrl + "\">",
                    msgLinkClose: '</a>',
                    refundLinkOpen: "<a href=\"" + refundUrl + "\">",
                    refundLinkClose: '</a>',
                }) })));
    };
    FeedbackForm.prototype.sellerSuggestion = function () {
        var url = url_helpers_1.default.orderPath({
            orderId: this.props.legacyOrderId,
        });
        return (React.createElement("div", null,
            React.createElement(sanitized_render_1.default, { html: html_translation_1.translateElement('b', 'discovery.feedbackForm.problemsWithYourOrder') }),
            React.createElement("br", null),
            React.createElement(sanitized_render_1.default, { html: I18n.t('discovery.feedbackForm.sellerSuggestion', {
                    linkOpen: "<a href=\"" + url + "\">",
                    linkClose: '</a>',
                }) })));
    };
    FeedbackForm.prototype.renderStartAConversation = function () {
        return (React.createElement("div", { className: "alert-box alert-box--blue size-80 mb-1", "data-start-conversation": true },
            React.createElement("div", { className: "mb-0" },
                this.props.isBuyer && this.buyerSuggestion(),
                !this.props.isBuyer && this.sellerSuggestion())));
    };
    FeedbackForm.prototype.renderStructuredFeedback = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "mb-2", "data-structured-feedback": true },
                React.createElement(form_group_1.default, { label: I18n.t('discovery.feedbackForm.shippingLabel') },
                    React.createElement("div", { className: "d-inline-block mr-2" },
                        React.createElement(form_group_with_radio_1.default, { label: I18n.t('discovery.feedbackForm.shippingSatisfactory'), fieldName: "shippingSatisfactory", inputName: "shippingSatisfactory-" + this.props.orderUuid, value: "true", updateField: this.updateShipping, checked: this.state.shippingSatisfactory === true })),
                    React.createElement("div", { className: "d-inline-block" },
                        React.createElement(form_group_with_radio_1.default, { label: I18n.t('discovery.feedbackForm.shippingNotSatisfactory'), fieldName: "shippingSatisfactory", inputName: "shippingNotSatisfactory-" + this.props.orderUuid, value: "false", updateField: this.updateShipping, checked: this.state.shippingSatisfactory === false })))),
            React.createElement("div", { className: "mb-2" },
                React.createElement(form_group_1.default, { label: I18n.t('discovery.feedbackForm.conditionLabel') },
                    React.createElement("div", { className: "d-inline-block mr-2" },
                        React.createElement(form_group_with_radio_1.default, { label: I18n.t('discovery.feedbackForm.conditionSatisfactory'), fieldName: "conditionSatisfactory", inputName: "conditionSatisfactory-" + this.props.orderUuid, value: "true", updateField: this.updateCondition, checked: this.state.conditionSatisfactory === true, required: true })),
                    React.createElement("div", { className: "d-inline-block" },
                        React.createElement(form_group_with_radio_1.default, { label: I18n.t('discovery.feedbackForm.conditionNotSatisfactory'), fieldName: "conditionSatisfactory", inputName: "conditionNotSatisfactory-" + this.props.orderUuid, value: "false", updateField: this.updateCondition, checked: this.state.conditionSatisfactory === false, required: true }))))));
    };
    FeedbackForm.prototype.render = function () {
        return (React.createElement("div", null,
            this.showStructuredFeedback() && this.renderStructuredFeedback(),
            React.createElement(form_group_1.default, { label: I18n.t('discovery.feedbackForm.rateTransaction') },
                React.createElement(star_rating_selector_1.default, { onSelect: this.starRatingSelected, rating: this.state.rating })),
            this.showStartAConversation() && this.renderStartAConversation(),
            React.createElement(form_group_with_input_1.default, { inputName: "message", id: "message-" + this.props.orderUuid, inputType: "textarea", label: I18n.t('discovery.feedbackForm.feedbackLabel'), updateField: this.onValueChange, value: this.state.message, maxLength: 500, displayCharacterCount: true, helpText: this.state.message ?
                    I18n.t('discovery.feedbackForm.feedbackPublicHint') : ' ' }),
            React.createElement("button", { className: "button", onClick: this.createFeedback, disabled: this.state.submitDisabled || !this.formValid() }, I18n.t('discovery.feedbackForm.sendFeedback'))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], FeedbackForm.prototype, "createFeedback", null);
    tslib_1.__decorate([
        bind_1.default
    ], FeedbackForm.prototype, "onSuccess", null);
    tslib_1.__decorate([
        bind_1.default
    ], FeedbackForm.prototype, "onError", null);
    tslib_1.__decorate([
        bind_1.default
    ], FeedbackForm.prototype, "onValueChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], FeedbackForm.prototype, "starRatingSelected", null);
    tslib_1.__decorate([
        bind_1.default
    ], FeedbackForm.prototype, "updateShipping", null);
    tslib_1.__decorate([
        bind_1.default
    ], FeedbackForm.prototype, "updateCondition", null);
    tslib_1.__decorate([
        bind_1.default
    ], FeedbackForm.prototype, "formValid", null);
    return FeedbackForm;
}(React.Component));
exports.FeedbackForm = FeedbackForm;
exports.default = react_apollo_1.compose(updateFeedbackMutation)(user_context_provider_1.withUserContext(FeedbackForm));
var templateObject_1;
//# sourceMappingURL=feedback_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/feedbacks/feedback_form.js
// module id = oXoM
// module chunks = 20 21